import { styled } from '@mui/material';

export const Wrapper = styled('div')(() => ({
  width: '100%',
  height: '100%',
  overflowY: 'auto',
}));

export const VirtualWrapper = styled('div', {
  shouldForwardProp: (prop) => prop !== 'height',
})<{ height: number }>(({ height }) => ({
  height: `${height}px`,
  width: '100%',
  position: 'relative',
}));

export const VirtualContent = styled('div', {
  shouldForwardProp: (prop) => prop !== 'start',
})<{ start?: number }>(({ start }) => ({
  position: 'absolute',
  top: 0,
  left: 0,
  width: '100%',
  transform: `translateY(${start ?? 0}px)`,
}));
